import { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FormHeader } from '@/components/forms';
import { UserEntitlementsList } from './list';
import { ChannelMembershipsList } from '../channel-memberships/list';
import { SubscriptionsList } from '../subscriptions/list';

/**
 * Объединённая страница доступов пользователей
 * Вкладка "Пользователи" — агрегированные entitlements
 * Вкладка "Подписки" — список подписок
 * Вкладка "Членство в каналах" — детальные channel memberships
 */
export function UserEntitlementsPage() {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="space-y-6">
      <FormHeader
        title="Доступы пользователей"
        description="Подписки, курсы, каналы и привилегии"
        sticky
        icon={<ShieldCheck className="h-5 w-5" />}
      />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="users">Пользователи</TabsTrigger>
          <TabsTrigger value="subscriptions">Владельцы абонементов</TabsTrigger>
          <TabsTrigger value="memberships">Членство в каналах</TabsTrigger>
        </TabsList>

        <TabsContent value="users" forceMount className="mt-4 data-[state=inactive]:hidden">
          <UserEntitlementsList />
        </TabsContent>

        <TabsContent value="subscriptions" forceMount className="mt-4 data-[state=inactive]:hidden">
          <SubscriptionsList />
        </TabsContent>

        <TabsContent value="memberships" forceMount className="mt-4 data-[state=inactive]:hidden">
          <ChannelMembershipsList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
